/** Cookie presence mirrors persisted refresh token for Next.js middleware routing only. */
export const SESSION_COOKIE_NAME = 'vunapay_session';
